import { render, staticRenderFns } from "./technicalBusinessScore.vue?vue&type=template&id=288c331f&scoped=true"
import script from "./technicalBusinessScore.vue?vue&type=script&lang=js"
export * from "./technicalBusinessScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288c331f",
  null
  
)

export default component.exports